import styled from 'styled-components';

export const TableRowBody = styled.tr`
  vertical-align: middle;
  height: 70px;
`;
